import {
  Conditional,
  CustomStyledLabel,
  RequestServiceContactInput,
  RequestServiceContactRadioInput,
  RequestServiceStepIndicator
} from '@cat-ecom/pcc-components';
import { CatHeading } from '@blocks-react/components/Heading';
import { useTranslations } from 'next-intl';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import clx from 'classnames';
import { hasHtmlInjectionTags } from '@cat-ecom/common/utils/stringUtils';
import { HTML_SPECIAL_CHAR_ERROR } from '@cat-ecom/common/utils/constants';
import { CatFieldset } from 'blocks-nextjs/blocks-react/components/Fieldset';
import {
  CONTACT_METHOD_TYPE,
  EMAIL_FORMAT_REGEX,
  PHONE_NUMBER_FORMAT_REGEX,
  EMAIL_METHOD,
  PHONE_METHOD,
  TEXT_METHOD,
  PHONE_NUMBER_MAXLENGTH
} from '../constant';
import styles from '../request-equipment-service.module.scss';

const RequestEquipmentServiceContactMethod = ({ isMobile, classname }) => {
  const t = useTranslations();
  const formMethods = useFormContext();
  const { watch } = formMethods;
  const contactType = watch('customer.contactMethod');
  const contactsMethod =
    contactType === PHONE_METHOD.name || contactType === TEXT_METHOD.name;
  const radioButton = useCallback(
    (item) => {
      const textClassName = clx({
        'mb-4 pb-2 mb-md-0 pb-md-0': item.name !== 'TEXT'
      });
      return (
        <RequestServiceContactRadioInput
          name="customer.contactMethod"
          value={item.name}
          classname="mr-4 pr-2"
          key={item.name}
        >
          <div className={textClassName}>
            <CustomStyledLabel>
              <CatHeading variant="body">
                <span className="u-color--Black">{t(item.translation)}</span>
              </CatHeading>
            </CustomStyledLabel>
          </div>
        </RequestServiceContactRadioInput>
      );
    },
    [t]
  );

  const validateInputSanity = (value) => {
    return hasHtmlInjectionTags(
      value,
      (t('ADD_INV_CHAR_NEW_FIELD_WARNING'),
      { 0: '', 1: HTML_SPECIAL_CHAR_ERROR })
    );
  };

  return (
    <div className={`${styles['divider']} mx-3`}>
      <div className="d-flex align-items-center justify-content-center my-4">
        <CatHeading variant="label">
          <CustomStyledLabel> {t('REQUEST_SERVICE_CONTACT')}</CustomStyledLabel>
        </CatHeading>
      </div>
      <div className={`${styles['request-service__name']}`}>
        <RequestServiceContactInput
          placeholder={t('EMPTY_CONTACT_NAME')}
          name="customer.contactName"
          label={t('MA_NAME')}
          hideWordCount={true}
          maxlength={100}
          type="text"
          rules={{
            required: {
              value: true,
              message: t('EMPTY_CONTACT_NAME')
            },
            validate: {
              validateInputSanity
            }
          }}
        />
      </div>
      <div className="mt-4">
        <CatFieldset {...(!isMobile && { orientation: 'horizontal' })}>
          {CONTACT_METHOD_TYPE.map((item) => radioButton(item))}
        </CatFieldset>
      </div>
      <div className={`mt-4 ${styles['request-service__name']}`}>
        <Conditional test={contactType === EMAIL_METHOD.name}>
          <RequestServiceContactInput
            placeholder={t('EMPTY_EMAIL')}
            name="customer.email"
            hideWordCount={true}
            type="email"
            maxlength={100}
            hideLabel={true}
            autocomplete="email"
            rules={{
              required: {
                value: true,
                message: t('EMPTY_EMAIL')
              },
              validate: {
                matchPattern: (value) =>
                  EMAIL_FORMAT_REGEX.test(value) || t('EMPTY_EMAIL')
              }
            }}
          />
        </Conditional>

        <Conditional test={contactsMethod}>
          <RequestServiceContactInput
            hideLabel={true}
            placeholder={t('EMPTY_CONTACT_NUMBER')}
            hideWordCount
            type="text"
            maxlength={PHONE_NUMBER_MAXLENGTH}
            name="customer.phone"
            rules={{
              required: {
                value: true,
                message: t('EMPTY_CONTACT_NUMBER')
              },
              validate: {
                matchPattern: (value) =>
                  PHONE_NUMBER_FORMAT_REGEX.test(value) ||
                  t('ERROR_INVALIDPHONE')
              }
            }}
          />
        </Conditional>
      </div>
      <Conditional test={isMobile}>
        <div className="pt-3">
          <RequestServiceStepIndicator classname={classname} />
        </div>
      </Conditional>
    </div>
  );
};
export default RequestEquipmentServiceContactMethod;
